<template>
    <v-sheet color="transparent" width="100%" height="100%" class="pt-8" style="text-align: -webkit-center;" :class="!isRAOS ? 'align-content-center' : ''"  >
        <v-sheet color="transparent" class="text-start hc-group__LOGO">
            <img
            :width="120"
            alt="Logo Smart Link"
            :src="require('@/assets/Images/hcgroup.jpg')"
            />
        </v-sheet>
            <img
            v-if="!isRAOS"
            :width="500"
            alt="Logo Smart Link"
            :src="require('@/assets/Images/logoSmartLink.png')"
            />
        <!-- <v-sheet color="transparent" :width="width"> -->
            <div v-if="isRAOS">
                <span class="LoginTitle">SmartLink™ RAOS </span>
            </div>
            <div v-if="isRAOS">
                <span class="LoginSubtitle"> Remote & Autonomous Operation System</span>
            </div>
        <!-- </v-sheet> -->
        <v-sheet class="defaultCard LoginCard" :width="width" >

            <!-- Form Login -->
            <v-form v-model="valid" @submit.prevent="submit">
                <v-container class="text-start">
                    <v-row class="text-black">

                        <v-col cols="12">
                        <v-text-field
                            v-model="userName"
                            :rules="fieldUserRules"
                            :label="t('labels.user')"
                            prepend-icon="mdi-account-hard-hat"
                            variant="outlined"
                            required
                        ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                        <v-text-field
                            v-model="password"
                            :rules="fieldPassRules"
                            :type="typePassword"
                            :append-inner-icon="iconAppend"
                            :label="t('labels.pass')"
                            prepend-icon="mdi-lock"
                            variant="outlined"
                            @click:append-inner="changeType()"
                            required
                        ></v-text-field>
                        </v-col>
                    
                    </v-row>
                </v-container>
                <!-- <v-divider class="my-5" :thickness="1"></v-divider> -->
                <v-btn type="submit" color="bgCircular" block class="btnLogin mt-2 mb-3 text-white" :disabled="!valid">{{t('buttons.login')}}</v-btn>
            </v-form>
        </v-sheet>
    </v-sheet>
    
</template>

<script setup lang="ts">
import { Ref, computed, ref } from 'vue';
import axios            from 'axios';
import router           from '@/router';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { md, smAndDown} = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTAPIS        from '@/constants/apis';
import { TIMEOUTTIME }  from '@/constants/apis';
import { TOKEN, VISIBLE_PAGES } from '@/constants/labels';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';


const projectName       = computed(() => store.state.projectName);
const isRAOS = computed(() => projectName.value === 'SmartLinkRAOS')


/**
 * Component
 */
const valid:Ref<boolean>        =   ref(false);
const userName:Ref<string>      =   ref('');
const password:Ref<string>      =   ref('');
const iconAppend                =   ref('mdi-eye');
const typePassword              =   ref('password');
const boolPassword              =   ref(true);
const width                     =   computed(() => md.value?'50%':smAndDown.value?'70%':'700px');

/**
 * Rules Fields
 */
const fieldPassRules = ref (
[
    (value:string) => {
    if (value) return true

    return t('labels.errors.passRequired')
    }
    
]);
const fieldUserRules = computed ( () =>
    [
    (v:string) => !!v || t('labels.errors.userRequired'),
    (v:string) => v.length >= 4 || t('labels.errors.userError'),
],
)

//==================================================//
//===================== METHODS ====================//
//==================================================//

/**
 * Show password
 */
const changeType = () =>{
    boolPassword.value = !boolPassword.value
    if(boolPassword.value){
        iconAppend.value        = 'mdi-eye';
        typePassword.value      = 'password';
    }else{
        iconAppend.value        = 'mdi-eye-off';
        typePassword.value      = 'text';
    }
}

    /**
 * Post Login Form to API
 */
const submit = async () => {
    const params = {
        user : userName.value,
        pass : password.value,
    }
    await axios.get(CONSTAPIS.APIS.value.general.login, { params : params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then(
        (element) =>{
            let sesion = element.data.body;
            
            if(sesion.status === 'User Found'){
                localStorage.setItem('user', sesion.user);
                store.commit('setUserSesion',sesion.user);
                localStorage.setItem('rol', sesion.rol);
                store.commit('setUserRol',sesion.rol);

                const finalURL = isRAOS.value ? `/smartlinkRAOS/${VISIBLE_PAGES.raosinit}` : `/smartlink/${VISIBLE_PAGES.dashboard}`
                router.push(finalURL)
                store.commit('setAppBarPage','smartlinkPage');
            }
            else {
                let msg = sesion.status === 'User Not Found' ? t('snackbar.login.userNotFound') : t('snackbar.login.passWrong') ; 
                
                userName.value = '';
                password.value = '';
                store.dispatch('showSnackBar', {type: 'setSnackError', msg: msg})
            }
        }
    )
    .catch(function (error) {
        showConsoleError(error);
    });
}

</script>

<style scoped>
.card-login{
    border: 2px solid rgba(0, 0, 0, 0.1);
    padding: 0 10px;
    margin: 120px auto 0px;
    border-radius: 20px;
}

.btnLogin{
    border-radius: 20px;
}
.SMLogo{
    flex: 0.5 0 auto !important;
}
.LoginSubtitle{
    font-weight: bold;
    font-size: 70px;
    /* color: rgb(29, 29, 188); */
    color: rgb(var(--v-theme-bgCircular));
}
.LoginTitle{
    font-weight: bold;
    font-size: 90px;
    color: black;
}
.LoginCard{
    background-color: rgba(255,255,255,.7);
}
.hc-group__LOGO{
    position: absolute;
    top: 3%;
    left: 3%;
}
</style>